// extracted by mini-css-extract-plugin
module.exports = {"page":"account_page__1hK44","pageTitle":"account_pageTitle__Ouvmw"};